<div class="ns-tab-page">
  <p class="ns-banner ns-banner--error" *ngIf="loadError">
    {{ loadError }}
    <button type="button" class="ns-link-btn" (click)="load()">Retry</button>
  </p>

  <p class="ns-banner ns-banner--warn" *ngIf="!loading && !loadError && accountEnabled">
    {{ accountEnabledMessage }}
  </p>

  <div class="ns-tpl-loader" *ngIf="loading">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <section class="bl-hero">
      <div class="bl-hero__top">
        <div class="bl-hero__brand">
          <img class="bl-hero__icon" src="assets/images/engagement-banner-image.svg" alt="" aria-hidden="true">
          <div>
            <h2>Blacklist / DND</h2>
            <p>
              Keep listed customers off invitations and reminders. Customer Notifier checks the fields below
              before a send and skips the request when a value matches.
            </p>
          </div>
        </div>
        <button type="button" class="bl-hero__setup" (click)="openSetup()">
          <i class="fa fa-cog" aria-hidden="true"></i>
          Setup
        </button>
      </div>

      <div class="bl-hero__grid">
        <article class="bl-metric">
          <span class="bl-metric__label">Service</span>
          <div class="bl-metric__status">
            <span class="bl-status__dot" [class.is-on]="savedEnabled"></span>
            <span class="bl-status__pill" [class.is-on]="savedEnabled">{{ savedEnabled ? 'Enabled' : 'Not enabled' }}</span>
          </div>
          <p *ngIf="savedEnabled">Matching customers are skipped on invitations and reminders.</p>
          <p *ngIf="!savedEnabled">Turn this on in Setup, choose tag fields, then add values to the list.</p>
        </article>

        <article class="bl-metric bl-metric--fields">
          <span class="bl-metric__label">
            Match fields
            <em>{{ savedFields.length }}</em>
          </span>
          <div class="bl-fields__box is-readonly" *ngIf="savedFields.length">
            <span class="bl-token" *ngFor="let field of savedFields">
              <strong>{{ fieldLabel(field) }}</strong>
              <small>{{ field }}</small>
            </span>
          </div>
          <p *ngIf="!savedFields.length">No tag fields selected yet. Open Setup to choose them.</p>
        </article>

        <article class="bl-metric bl-metric--add">
          <span class="bl-metric__label">Add to list</span>
          <div class="bl-quick-add" *ngIf="canQuickAdd">
            <button type="button" class="bl-quick-add__action" (click)="openRecordsSetup()">
              <span class="bl-quick-add__icon" aria-hidden="true">
                <i class="fa fa-plus"></i>
              </span>
              <span class="bl-quick-add__copy">
                <strong>Add one value</strong>
                <small>Open Setup to enter a single record</small>
              </span>
            </button>
            <button type="button" class="bl-quick-add__action" (click)="openRecordsSetup()">
              <span class="bl-quick-add__icon" aria-hidden="true">
                <i class="fa fa-cloud-upload"></i>
              </span>
              <span class="bl-quick-add__copy">
                <strong>Add many from CSV</strong>
                <small>Download a sample, then upload up to 5,000 rows</small>
              </span>
            </button>
          </div>
          <p *ngIf="!canQuickAdd">Turn the service on and choose match fields in Setup first.</p>
        </article>
      </div>
    </section>

    <div class="version-history-container" *ngIf="savedEnabled">
      <div class="search-pagination-container">
        <div class="drafts-header">
          <h3>Blacklist entries</h3>
        </div>
        <div class="pagination-controls">
          <div class="bl-search unsub-search">
            <div class="search-box" [class.unsub-search--open]="showSearchFields">
              <i class="fa fa-search search-icon"></i>
              <input
                type="text"
                [(ngModel)]="listSearchQuery"
                name="listSearchQuery"
                [placeholder]="searchPlaceholder"
                [title]="'Enter the complete ' + listFieldLabel + ' and press Enter'"
                (ngModelChange)="onListSearchQueryChange()"
                (keyup.enter)="applyListSearch()"
                autocomplete="off"
              >
              <button type="button" class="clear-button" *ngIf="listSearchQuery" (click)="clearListSearch()">
                <i class="fa fa-times"></i>
              </button>
              <button type="button" class="unsub-search__fields-btn" (click)="toggleSearchFields($event)" aria-label="Choose search field">
                <img src="assets/images/menu-down-dark.svg" alt="">
              </button>
            </div>
            <ul class="unsub-search__list" *ngIf="showSearchFields">
              <li
                *ngFor="let option of searchFieldOptions"
                [class.is-active]="option.id === (selectedSearchField || listFieldKey)"
                (click)="chooseSearchField(option.id)"
              >
                {{ option.label }}
              </li>
            </ul>
            <p class="bl-search__hint" *ngIf="searchNeedsEnter">Enter the complete value and press Enter</p>
          </div>
            <button type="button" (click)="goToFirstPage()" [disabled]="page <= 1 || entriesLoading || !total">
              <img src="assets/images/chevron-double-left.svg" alt="First">
            </button>
            <button type="button" (click)="previousPage()" [disabled]="page <= 1 || entriesLoading || !total">
              <img src="assets/images/chevron-left.svg" alt="Previous">
            </button>
            <div class="pagination-text">
              {{ rangeStart }} - {{ rangeEnd }} of {{ total }}
            </div>
            <button type="button" (click)="nextPage()" [disabled]="page >= pageCount || entriesLoading || !total">
              <img src="assets/images/chevron-right.svg" alt="Next">
            </button>
            <button type="button" (click)="goToLastPage()" [disabled]="page >= pageCount || entriesLoading || !total">
              <img src="assets/images/chevron-double-right.svg" alt="Last">
            </button>
        </div>
      </div>

      <div class="table-responsive version-table" *ngIf="entries.length || entriesLoading">
        <div class="table-overlay" *ngIf="entriesLoading">
          <app-ltms-loader></app-ltms-loader>
        </div>
        <table>
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>
              <th>Added On</th>
              <th>Added By</th>
              <th class="action-header-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of entries">
              <td>{{ fieldLabel(row.key) }}</td>
              <td>{{ row.value }}</td>
              <td class="ns-nowrap">{{ createdOn(row) ? (createdOn(row) | date: 'dd-MMM-yy HH:mm') : '—' }}</td>
              <td>
                <span class="ns-text" [title]="createdByTitle(row)">{{ createdBy(row) }}</span>
              </td>
              <td class="action-column-cell">
                <button
                  type="button"
                  class="restore-button"
                  [class.is-unauthorized]="!isWriteAllowed"
                  (click)="askRemove(row)"
                >
                  Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="no-data-container" *ngIf="!entries.length && !entriesLoading">
        <div class="no-data-message">No listed values yet. Open Setup to add one value or many from a CSV.</div>
      </div>
    </div>
  </ng-container>
</div>

<div class="reports-side-panel" *ngIf="setupOpen">
  <div class="side-panel-overlay" (click)="closeSetup()"></div>
  <div class="side-panel-container" role="dialog" aria-modal="true" aria-labelledby="ns-blacklist-setup-title">
    <div class="side-panel-header">
      <div class="header-label" id="ns-blacklist-setup-title">Setup</div>
      <button type="button" class="close-button" (click)="closeSetup()" aria-label="Close">×</button>
    </div>

    <div class="schedule-wizard-tabs" role="tablist" aria-label="Blacklist setup steps">
      <button
        type="button"
        class="schedule-wizard-tab"
        [class.active]="setupStep === 'service'"
        (click)="setSetupStep('service')"
      >
        <span class="schedule-wizard-step">1</span>
        Service
      </button>
      <span class="schedule-wizard-connector"></span>
      <button
        type="button"
        class="schedule-wizard-tab"
        [class.active]="setupStep === 'records'"
        [disabled]="setupStep !== 'records' && !canGoToRecords"
        [attr.title]="setupStep !== 'records' ? (nextSetupDisabledReason || null) : null"
        (click)="setSetupStep('records')"
      >
        <span class="schedule-wizard-step">2</span>
        Records
      </button>
    </div>

    <div class="side-panel-content">
      <p class="ns-banner ns-banner--warn" *ngIf="accountEnabled">{{ accountEnabledMessage }}</p>

      <ng-container *ngIf="setupStep === 'service'">
        <section class="form-section">
          <h3 class="form-section-title">Service</h3>
          <div class="form-group">
            <label class="checkbox-label">
              <input type="checkbox" [(ngModel)]="enabled" name="enabled" [disabled]="!canEdit">
              <span>
                Enable Blacklist / DND
                <small class="template-description">When on, Customer Notifier skips a request if any selected field matches a listed value.</small>
              </span>
            </label>
          </div>
        </section>

        <section class="form-section">
          <h3 class="form-section-title">Match these fields</h3>
          <p class="template-description">Choose up to 2 tag_* fields. Customer Notifier matches listed values against these tags.</p>
          <div class="bl-fields" *ngIf="fieldOptions.length || selectedFields.length" (click)="$event.stopPropagation()">
            <div
              class="bl-fields__box"
              [class.is-open]="fieldMenuOpen"
              [class.is-dirty]="configDirty"
              [class.is-readonly]="!canEdit"
            >
              <span class="bl-token" *ngFor="let field of selectedFields">
                <strong>{{ fieldLabel(field) }}</strong>
                <small>{{ field }}</small>
                <button
                  type="button"
                  class="bl-token__remove"
                  *ngIf="canEdit"
                  [class.is-unauthorized]="!isWriteAllowed"
                  [attr.aria-label]="'Remove ' + fieldLabel(field)"
                  (click)="removeSelectedField(field); $event.stopPropagation()"
                >
                  ×
                </button>
              </span>
              <button
                type="button"
                class="bl-fields__add"
                *ngIf="canEdit"
                [disabled]="!canEdit || !fieldOptions.length"
                [class.is-unauthorized]="!isWriteAllowed"
                (click)="toggleFieldMenu($event)"
              >
                {{ selectedFields.length ? 'Add field' : 'Select tag fields' }}
              </button>
            </div>
            <div class="bl-multi__menu" *ngIf="fieldMenuOpen && canEdit">
              <label class="bl-multi__search">
                <img src="assets/images/magnify.svg" alt="" aria-hidden="true">
                <input
                  type="text"
                  [(ngModel)]="fieldQuery"
                  name="fieldQuery"
                  placeholder="Search tag fields"
                  autocomplete="off"
                  (click)="$event.stopPropagation()"
                  (ngModelChange)="onFieldQueryChange()"
                >
              </label>
              <div class="bl-multi__list">
                <label class="checkbox-label bl-multi__option" *ngFor="let option of filteredFieldOptions">
                  <input
                    type="checkbox"
                    [checked]="selectedFields.includes(option.id)"
                    [disabled]="!canEdit || (atFieldLimit && !selectedFields.includes(option.id))"
                    (change)="toggleField(option.id)"
                  >
                  <span class="bl-multi__option-copy">
                    <strong>{{ option.label }}</strong>
                    <small>{{ option.id }}</small>
                  </span>
                </label>
                <p class="bl-multi__empty" *ngIf="atFieldLimit">Maximum of 2 fields. Remove one to choose another.</p>
                <p class="bl-multi__empty" *ngIf="!filteredFieldOptions.length">No matching tag fields.</p>
              </div>
            </div>
          </div>
          <p class="template-description" *ngIf="!fieldOptions.length && !selectedFields.length">No tag_* project fields were found.</p>
        </section>
      </ng-container>

      <ng-container *ngIf="setupStep === 'records'">
        <section class="form-section">
          <h3 class="form-section-title">Add one</h3>
          <p class="template-description">Customer Notifier stores the value the same way it looks it up on send.</p>
          <div class="bl-add-one">
            <div class="bl-add-one__field">
              <span>Field</span>
              <button
                type="button"
                class="bl-dropdown"
                [class.is-open]="draftFieldMenuOpen"
                [class.is-placeholder]="!draftKey"
                [disabled]="!canEdit"
                (click)="toggleDraftFieldMenu($event)"
              >
                <span>{{ draftFieldLabel }}</span>
                <img src="assets/images/menu-down-dark.svg" alt="" aria-hidden="true">
              </button>
              <ul class="bl-dropdown__list" *ngIf="draftFieldMenuOpen">
                <li
                  *ngFor="let field of selectedFields"
                  [class.is-active]="draftKey === field"
                  (click)="chooseDraftField(field, $event)"
                >
                  <strong>{{ fieldLabel(field) }}</strong>
                  <small>{{ field }}</small>
                </li>
              </ul>
            </div>
            <label>
              <span>Value</span>
              <div class="bl-add-one__value">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="draftValue"
                  name="draftValue"
                  [disabled]="!canEdit"
                  [attr.maxlength]="valueMaxLength"
                  [placeholder]="draftValuePlaceholder"
                  (keyup.enter)="addEntry()"
                >
                <button
                  type="button"
                  class="bl-add-one__clear"
                  *ngIf="draftValue"
                  [disabled]="!canEdit"
                  aria-label="Clear value"
                  (click)="clearDraftValue($event)"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </label>
            <button
              type="button"
              class="btn-save bl-add-one__btn"
              [class.is-unauthorized]="!isWriteAllowed"
              [disabled]="isWriteAllowed && adding"
              (click)="addEntry()"
            >
              {{ adding ? 'Adding…' : 'Add' }}
            </button>
          </div>
        </section>

        <section class="form-section">
          <h3 class="form-section-title">Add many from CSV</h3>
          <p class="template-description">
            Download the sample, replace the example values, then upload up to 5,000 values. Use one column per selected field.
          </p>
          <div class="bl-csv">
            <div class="bl-csv__row">
              <button type="button" class="btn-cancel bl-csv__sample" (click)="downloadSampleCsv()">
                <i class="fa fa-download" aria-hidden="true"></i>
                <span>
                  <strong>Download sample CSV</strong>
                  <small>Edit this file, then upload it</small>
                </span>
              </button>
              <label class="bl-csv__pick" [class.is-disabled]="!canEdit">
                <input type="file" accept=".csv,text/csv" [disabled]="!canEdit" (change)="onCsvFile($event)">
                <span class="bl-csv__icon" aria-hidden="true">
                  <i class="fa fa-cloud-upload"></i>
                </span>
                <span class="bl-csv__copy">
                  <strong>{{ csvName ? csvName : 'Upload CSV' }}</strong>
                  <small *ngIf="!csvName">Choose a file or drop it here</small>
                  <small *ngIf="csvName">
                    {{ csvGrid.length ? csvGrid.length + ' rows · ' : '' }}{{ csvPreview.length }} unique{{ csvCellCount > csvPreview.length ? ' of ' + csvCellCount : '' }}{{ csvInvalid.length ? ', ' + csvInvalid.length + ' skipped' : '' }}
                  </small>
                </span>
              </label>
            </div>
            <div class="bl-csv__preview" *ngIf="csvPreview.length">
              <table *ngIf="csvColumns.length">
                <thead>
                  <tr>
                    <th *ngFor="let col of csvColumns">{{ fieldLabel(col) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let line of csvGrid.slice(0, 6)">
                    <td *ngFor="let value of line">{{ value || '—' }}</td>
                  </tr>
                </tbody>
              </table>
              <table *ngIf="!csvColumns.length">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of csvPreview.slice(0, 6)">
                    <td>{{ fieldLabel(row.key) }}</td>
                    <td>{{ row.value }}</td>
                  </tr>
                </tbody>
              </table>
              <p class="template-description" *ngIf="csvGrid.length > 6">Showing first 6 of {{ csvGrid.length }} rows.</p>
              <p class="template-description" *ngIf="!csvColumns.length && csvPreview.length > 6">Showing first 6 of {{ csvPreview.length }}.</p>
            </div>
            <p class="ns-error" *ngIf="csvInvalid[0]">{{ csvInvalid[0] }}</p>
            <div class="ns-csv__actions" *ngIf="csvPreview.length">
              <button type="button" class="btn-cancel" (click)="clearCsv()">Clear file</button>
              <button
                type="button"
                class="btn-save"
                [class.is-unauthorized]="!isWriteAllowed"
                [disabled]="isWriteAllowed && importing"
                (click)="startImport()"
              >
                {{ importing ? 'Importing…' : 'Import ' + csvPreview.length }}
              </button>
            </div>
          </div>
        </section>

      </ng-container>
    </div>

    <div class="side-panel-footer">
      <button
        type="button"
        class="btn-cancel"
        *ngIf="setupStep === 'service'"
        [disabled]="!configDirty || busy"
        (click)="discardConfig()"
      >
        Discard
      </button>
      <span *ngIf="setupStep === 'records'"></span>
      <div class="side-panel-footer-actions">
        <button
          type="button"
          class="btn-cancel"
          *ngIf="setupStep === 'records'"
          [disabled]="busy"
          (click)="setSetupStep('service')"
        >
          Back
        </button>
        <button type="button" class="btn-cancel" (click)="closeSetup()">{{ setupStep === 'records' ? 'Done' : 'Cancel' }}</button>
        <button
          type="button"
          class="btn-save"
          *ngIf="setupStep === 'service'"
          [class.is-unauthorized]="!isWriteAllowed"
          [disabled]="isWriteAllowed && (busy || !canGoToRecords)"
          [attr.title]="nextSetupDisabledReason || null"
          (click)="goToRecords()"
        >
          {{ saving ? 'Saving…' : 'Next' }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="ns-confirm" *ngIf="confirmImport">
  <div class="ns-confirm__overlay" (click)="confirmImport = false"></div>
  <div class="ns-confirm__card">
    <h3>Import these values?</h3>
    <p>
      {{ csvPreview.length }} unique values will be added{{ csvCellCount > csvPreview.length ? ' from ' + csvCellCount + ' cells' : '' }}.
      Repeated values and values already on the list are skipped.
    </p>
    <div class="ns-confirm__actions">
      <button type="button" class="ns-save ns-save--ghost" (click)="confirmImport = false">Don't continue</button>
      <button type="button" class="ns-save" [disabled]="importing" (click)="confirmImportNow()">Yes, continue</button>
    </div>
  </div>
</div>

<div class="ns-confirm" *ngIf="confirmRemove">
  <div class="ns-confirm__overlay" (click)="confirmRemove = null"></div>
  <div class="ns-confirm__card">
    <h3>Remove this value?</h3>
    <p>{{ fieldLabel(confirmRemove.key) }} · {{ confirmRemove.value }} will be taken off the Blacklist / DND list.</p>
    <div class="ns-confirm__actions">
      <button type="button" class="ns-save ns-save--ghost" (click)="confirmRemove = null">Don't continue</button>
      <button type="button" class="ns-save" (click)="confirmRemoveNow()">Yes, continue</button>
    </div>
  </div>
</div>
